import capitalize from 'lodash/capitalize';

export const fullName = (object = {}) => (
  `${object.first_name || object.firstName || ""} ${object.last_name || object.lastName || ""}`
);

export const tAttribute = (model, name) => {
  return I18n.t(`activerecord.attributes.${model}.${name}`);
}

export const tModel = (model, modifier = "one") => {
  return I18n.t(`activerecord.models.${model}.${modifier}`);
}

export const ta = (stuff) => {
  return I18n.t(`activerecord.attributes.${stuff}`);
}

// Check if pending product has default (to edit 'directly' on product).
export const checkDefaultForPending = (product) => {
  if(product.shopify_id){
    return product.variants.length == 1 && product.variants[0].title == "Default Title"
  }
  else{
    // Not yet published product
    return product.variants.length == 0; // Default variant hasn't been created yet
  }
}

/**
 * Useful function to display the data of a list of records based on the objects list and how to display them.
 * @param { object } record - The record to get the display value from
 * @param { object } columnInfo  - The column info to know how to display this "cell" (must have AT least accessor property)
 * @param { object } utils - Utils attributes or functions passed to the cell builder when accessor is a function
 * @returns return a value or component depending on the columnInfo properties
 */
export const renderAccessorValue = (record, columnInfo, utils = null) => {
  const { accessor, attribute } = columnInfo; // Normal render using accessor/attribute provided
  if (typeof (accessor) == "string" || attribute) {
    return attribute ? record[attribute] : record[accessor]; // record['attribute']
  } else {
    return accessor(record, utils); // accessor as function like (record) => fullName(record)
  }
}

export const combineOptions = (options) => {
  // for( let option in options.slice(1)){ // For options 2 and 3
  // for(let combination in combinedOptions){
  // let newCombinations = combination.map()
  // }
  // }

  // combinedOptions = optionsValues[0].map((optionA) => {
  //   for (let optionB of optionsValues[1]) {
  //     if (optionsCount > 2) {
  //       for (optionC of optionsValues[2]) {
  //         [optionA, optionB, optionC]
  //       }
  //     }
  //     else {
  //       return [optionA, optionB]
  //     }
  //   }
  // });
  
  let optionsValues = options.map(option => option.values);
  let optionsCount = options.length;
  let combinedOptions = [];

  if(optionsCount > 1){
    for (let optionA of optionsValues[0]) {
      for (let optionB of optionsValues[1]) {
        if (optionsCount > 2) {
          for (optionC of optionsValues[2]) {
            combinedOptions = combinedOptions.concat([[optionA, optionB, optionC]]);
          }
        }
        else {
          combinedOptions = combinedOptions.concat([[optionA, optionB]]);
        }
      }
    }
  }
  else{
    combinedOptions = optionsValues[0];
  }

  console.log("Combined options ==> ", combinedOptions);
  return combinedOptions;
}

// Generate image url on client for file or display placeholder
const validImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/webp'];
export const getFileURL = (file) => {
  if(file.url){
    return file.url
  }
  else{
    return validImageTypes.indexOf(file.type) > 0 ? window.URL.createObjectURL(file) : 'https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304'
  }
}

// Recursive writing of FormData  (mostly to insert images along with data). nestedLeveName as in "sublinks" to translate to "sublinks_attributes"
export const recursiveWriteFormForRecords = (formData, parentName, records, nestedLevelName = null, imageFieldAliases = null ) => {
  let index = 0;
  for(let record of records ){
    const formDataNameAccessor = `${parentName}[${index}]`; // i.e. "section[app_links_attributes][0] / section[app_links_attributes][0][sublinks][0]
    writeSimpleFieldsOnFormData(formData, formDataNameAccessor, record, imageFieldAliases)
    if(record[nestedLevelName]){
      recursiveWriteFormForRecords(formData, `${formDataNameAccessor}[${nestedLevelName}_attributes]`, record[nestedLevelName], imageFieldAliases) // Write for children i.e. record["sublinks"] => wrire into record["sublinks_attributes"]. 
    }
    index += 1;
  }
}

// TODO omit sublinks and app_links. parentName as in "app_links", "banners", "app_links[x].sublinks[y]"
// TODO make imageUpload fields flexible like a list of items ["imageUpload", "imageMobileUpload"] || [{ "imageUpload": "image", "imageMobileUpload": "image_mobile_upload" }] etc
export const writeSimpleFieldsOnFormData = (formData, parentName, object, imageFieldAliases = null ) => {
  for(let fieldName of Object.keys(object)){ // write link attributes
    // console.group("DebugWriteSimpleFields")
    // console.log("FieldName", fieldName);
    // console.log("value", object[fieldName]);
    // console.groupEnd("DebugWriteSimpleFields")
    if(object[fieldName] != null){ // Do not write "nulls"
      if(fieldName == "imageUpload"){
        formData.append(`${parentName}[image]`, object[fieldName], object[fieldName].name);
      }
      else if( imageFieldAliases && imageFieldAliases[fieldName] ){ // example imageFieldAliases["image_desktop_upload"] which translates into "image_desktop" with imageFieldAliases value { "image_desktop_upload": "image_desktop" }
        const formFieldName = imageFieldAliases[fieldName];
        formData.append(`${parentName}[${formFieldName}]`, object[fieldName], object[fieldName].name); // i.e. formData.append(section[banner_attributes][0][image_desktop], object[image_desktop_upload], object[image_desktop_upload].name )
      }
      else if( Array.isArray(object[fieldName]) ){ // for simple array append as []
        object[fieldName].forEach( (item) => formData.append(`${parentName}[${fieldName}][]`, item)  )
      }
      else{
        formData.append(`${parentName}[${fieldName}]`, object[fieldName]) // i.e. "section[app_links_attributes][0][title]"
      }
    }
  }
}

// For dashboard custom range
export const calculateDays = (dateStart, dateEnd)=>{
  dateStart = new Date(dateStart);
  dateEnd = new Date(dateEnd);

  const dateStartMonthIndex = dateStart.getMonth() + 1; // +1 to match rails translations which is index 1+
  const dateEndMonthIndex = dateEnd.getMonth() + 1;

  if( dateStartMonthIndex === dateEndMonthIndex  && dateStart.getDate() === dateEnd.getDate() ){
    return `${ capitalize(I18n.t(`date.abbr_month_names`)[dateStartMonthIndex]) } ${dateStart.getDate()}`
  }
  else if( dateStartMonthIndex === dateEndMonthIndex && dateStart.getDate() != dateEnd.getDate()){
    return (
      `${ capitalize(I18n.t(`date.abbr_month_names`)[dateStartMonthIndex]) } ${dateStart.getDate()} - ${dateEnd.getDate()}`
    )
  }
  else{
    return (
      `${ capitalize(I18n.t(`date.abbr_month_names`)[dateStartMonthIndex]) } ${dateStart.getDate()} - ${capitalize(I18n.t(`date.abbr_month_names`)[dateEndMonthIndex])} ${dateEnd.getDate()}`
    )
  }
}